import { Plus, Trash2, ChevronUp, ChevronDown } from "lucide-react";
import { labelFor } from "@/lib/labels";
import Primitive from "./Primitive";
import AutoForm from "./AutoForm";

function cloneEmpty(obj) {
  if (Array.isArray(obj)) return obj.length ? [cloneEmpty(obj[0])] : [];
  if (obj && typeof obj === "object") {
    const out = {};
    for (const k of Object.keys(obj)) out[k] = cloneEmpty(obj[k]);
    return out;
  }
  if (typeof obj === "boolean") return false;
  if (typeof obj === "number") return 0;
  return "";
}

export default function ArrayField({ fieldKey, value, onChange }) {
  const isObjArr = value.length > 0 && typeof value[0] === "object" && value[0] !== null;
  const template = value.length ? cloneEmpty(value[0]) : "";

  const move = (idx, dir) => {
    const j = idx + dir;
    if (j < 0 || j >= value.length) return;
    const arr = [...value];
    [arr[idx], arr[j]] = [arr[j], arr[idx]];
    onChange(arr);
  };
  const setAt = (idx, nv) => {
    const arr = [...value];
    arr[idx] = nv;
    onChange(arr);
  };

  return (
    <div className="rounded-xl border border-stone-200 p-4 bg-stone-50/60">
      <div className="flex items-center justify-between mb-3">
        <span className="text-sm font-semibold text-stone-700">{labelFor(fieldKey)}</span>
        <button type="button" onClick={() => onChange([...value, template])} className="inline-flex items-center gap-1 text-sm text-[var(--c-primary)] hover:underline">
          <Plus className="h-4 w-4" /> যোগ করুন
        </button>
      </div>
      <div className="space-y-3">
        {value.map((item, idx) => (
          <div key={idx} className="rounded-lg border border-stone-200 bg-white p-3">
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs text-stone-400">#{idx + 1}</span>
              <div className="flex items-center gap-1">
                <button type="button" onClick={() => move(idx, -1)} className="p-1 text-stone-400 hover:text-stone-700"><ChevronUp className="h-4 w-4" /></button>
                <button type="button" onClick={() => move(idx, 1)} className="p-1 text-stone-400 hover:text-stone-700"><ChevronDown className="h-4 w-4" /></button>
                <button type="button" onClick={() => onChange(value.filter((_, i2) => i2 !== idx))} className="p-1 text-red-400 hover:text-red-600"><Trash2 className="h-4 w-4" /></button>
              </div>
            </div>
            {isObjArr ? (
              <AutoForm value={item} onChange={(nv) => setAt(idx, nv)} />
            ) : (
              <Primitive fieldKey={fieldKey} value={item} onChange={(nv) => setAt(idx, nv)} />
            )}
          </div>
        ))}
        {value.length === 0 ? <p className="text-sm text-stone-400">কোনো আইটেম নেই।</p> : null}
      </div>
    </div>
  );
}
